var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subject-info-form',{attrs:{"serverValidations":_vm.serverValidations},on:{"on-submit":_vm.addSubject}})}
var staticRenderFns = []

export { render, staticRenderFns }